export const accentOptions = [
  { id: 'steel', label: 'スチールブルー', light: '#3b5f94', dark: '#8fb0e3' },
  { id: 'teal', label: 'ティール', light: '#1f6f70', dark: '#5cc4c4' },
  { id: 'indigo', label: 'インディゴ', light: '#4a4e8f', dark: '#a9a6e6' },
  { id: 'sunset', label: 'サンセット', light: '#b4462b', dark: '#f0947c' },
  { id: 'green', label: 'グリーン', light: '#3d6b4a', dark: '#7cc08f' },
  { id: 'graphite', label: 'グラファイト', light: '#36454f', dark: '#b9c4cc' },
] as const;
export const backgroundOptions = [
  { id: 'neutral', label: 'ニュートラル' },
  { id: 'warm', label: 'ウォーム' },
  { id: 'cool', label: 'クール' },
  { id: 'navy', label: 'ネイビー' },
  { id: 'forest', label: 'フォレスト' },
  { id: 'black', label: 'ブラック' },
] as const;
export const styleOptions = [
  { id: 'standard', label: '標準' },
  { id: 'soft', label: 'やわらか' },
  { id: 'sharp', label: 'シャープ' },
  { id: 'glass', label: 'ガラス' },
] as const;
export const selectOptions = {
  mode: [
    { id: 'auto', label: '自動' },
    { id: 'light', label: 'ライト' },
    { id: 'dark', label: 'ダーク' },
  ],
  accent: accentOptions,
  density: [
    { id: 'comfortable', label: 'ゆったり' },
    { id: 'compact', label: '詰める' },
  ],
  fontSize: [
    { id: 'small', label: '小' },
    { id: 'standard', label: '標準' },
    { id: 'large', label: '大' },
  ],
  motion: [
    { id: 'standard', label: '標準' },
    { id: 'reduced', label: '減らす' },
  ],
} as const;
export type Appearance = {
  [K in keyof typeof selectOptions]: (typeof selectOptions)[K][number]['id'];
} & {
  background: (typeof backgroundOptions)[number]['id'];
  style: (typeof styleOptions)[number]['id'];
};
export function defaultAppearance(): Appearance {
  return {
    mode: 'auto',
    accent: 'steel',
    background: 'neutral',
    style: 'standard',
    density: 'comfortable',
    fontSize: 'standard',
    motion: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'reduced' : 'standard',
  };
}
const options = { ...selectOptions, background: backgroundOptions, style: styleOptions };
export function currentAppearance(): Appearance {
  const defaults = defaultAppearance();
  const data = document.documentElement.dataset;
  return Object.fromEntries(
    Object.entries(options).map(([key, choices]) => [
      key,
      choices.find((option) => option.id === data[key === 'mode' ? 'theme' : key])?.id ??
        defaults[key as keyof Appearance],
    ]),
  ) as Appearance;
}
export function applyAppearance(value: Appearance): void {
  for (const [key, setting] of Object.entries(value)) {
    document.documentElement.dataset[key === 'mode' ? 'theme' : key] = setting;
  }
}
export function saveAppearance(value: Appearance): boolean {
  try {
    localStorage.setItem('mc-panel-appearance', JSON.stringify(value));
    applyAppearance(value);
    return true;
  } catch (error) {
    console.warn('表示設定を保存できませんでした', error);
    applyAppearance(defaultAppearance());
    return false;
  }
}
